import { isName, isEmail } from './validator-helpers';

export const createCustomerAdminValidators = {
  name: {
    validate: isName,
    error: 'Validator.Name',
  },
  family_name: {
    validate: isName,
    error: 'Validator.Name',
  },
  email: {
    validate: isEmail,
    error: 'Validator.Email',
  },
};
